<template>
  <div>
    <div
      v-if="showBanner"
      class="banner-wrap mb-4"
    >
      <img
        src="@/assets/image/Banner.png"
        alt="banner"
        class="banner-img w-100"
      >
      <div class="banner-content">
        <div class="banner-title font-weight-bold">
          Welcome, {{ userFullName }}!
        </div>
        <div class="banner-desc">
          Welcome to the {{ companyName }} Fit Daily Monitoring Dashboard. We hope you have a productive and enjoyable day.
        </div>
        <button
          class="btn btn-info btn-sm font-weight-semi-bold banner-btn"
          type="button"
          @click="seeMonitoring"
        >
          See Monitoring Data
        </button>
      </div>
      <!-- <button
        class="banner-close"
        type="button"
        @click="showBanner = false"
      >
        <i class="fa fa-times" />
      </button> -->
      <img
        src="@/assets/image/people.png"
        alt="people"
        class="people-img"
      >
    </div>
    <div class="row">
      <div
        v-for="(item, i) in items"
        :key="item.key"
        class="col-12 col-md-4 mt-3"
        :class="{
          'mt-0': i === 0,
          'mt-md-0': i < 3
        }"
      >
        <div class="card kpi-card h-100">
          <div
            class="card-body p-3"
            :class="{ 'kpi-clickable': item.key === 'unsubmittedResponse' }"
            @click="onCardClick(item)"
          >
            <div class="d-flex align-items-start">
              <div class="kpi-icon mr-3">
                <i
                  class="fa"
                  :class="item.icon"
                />
              </div>
              <div class="flex-grow-1">
                <small class="text-muted d-block">
                  {{ item.label }}
                </small>
                <div class="font-weight-bold kpi-value">
                  {{ item.value }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    stats: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    showBanner: true
  }),

  computed: {
    userFullName () {
      try {
        const profile = JSON.parse(localStorage.getItem('profile') || '{}')
        return profile?.fullname || profile?.fullName || 'User'
      } catch {
        return 'User'
      }
    },
    companyName () {
      const profile = JSON.parse(localStorage.getItem('profile') || '{}')
      return profile?.company?.name || ''
    },
    items () {
      return [
        {
          key: 'totalEmployee',
          label: 'Total Employee',
          value: this.stats.totalEmployee,
          icon: 'fa-user'
        },
        {
          key: 'fit',
          label: 'Fit',
          value: this.stats.fit,
          icon: 'fa-heart'
        },
        {
          key: 'unfit',
          label: 'Unfit',
          value: this.stats.unfit,
          icon: 'fa-medkit'
        },
        {
          key: 'totalResponded',
          label: 'Total Responded',
          value: this.stats.totalResponded,
          icon: 'fa-check-square-o'
        },
        {
          key: 'fitFollowUp',
          label: 'Fit Follow Up',
          value: this.stats.fitFollowUp,
          icon: 'fa-exclamation-circle'
        },
        {
          key: 'unsubmittedResponse',
          label: 'Unsubmitted Response',
          value: this.stats.unsubmittedResponse,
          icon: 'fa-inbox'
        }
      ]
    }
  },

  methods: {
    seeMonitoring () {
      const lang = this.$i18n?.locale || 'en'
      this.$router.push(`/${lang}/all-assessment`)
    },
    onCardClick (item) {
      if (item.key === 'unsubmittedResponse') {
        this.$emit('openUnsubmittedResponse')
      }
    }
  }
}
</script>

<style scoped>
.kpi-card {
  border-radius: 12px;
}

.kpi-clickable {
  cursor: pointer;
}

.kpi-clickable:active {
  transform: translateY(1px);
}

.kpi-icon {
  align-items: center;
  background: #f1f7ff;
  border-radius: 10px;
  color: #18b2bd;
  display: flex;
  height: 34px;
  justify-content: center;
  width: 34px;
}

.kpi-value {
  font-size: 16px;
  line-height: 1.2;
}

.font-weight-semi-bold {
  font-weight: 600;
}

.banner-wrap {
  position: relative;
  font-size: clamp(12px, 1.1vw, 16px);
}

.banner-img {
  display: block;
}

.banner-content {
  color: #ffffff;
  left: 1.25em;
  position: absolute;
  right: 1.25em;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-right: 13em;
  z-index: 2;
}

.banner-title {
  font-size: 1.35em;
  line-height: 1.2;
}

.banner-desc {
  font-size: 0.9em;
  line-height: 1.4;
  margin-top: 0.5em;
  max-width: 44em;
  opacity: 0.95;
}

.banner-btn {
  border-radius: 8px;
  display: inline-flex;
  width: auto;
  font-size: 0.9em;
  line-height: 1.2;
  margin-top: 0.9em;
  padding: 0.55em 1.05em;
  max-width: max-content;
  white-space: nowrap;
}

.banner-close {
  align-items: center;
  background: #ffffff;
  border: 0;
  border-radius: 10px;
  color: #18b2bd;
  display: flex;
  height: 34px;
  justify-content: center;
  padding: 0;
  position: absolute;
  right: 0.75em;
  top: 0.75em;
  width: 2.4em;
  z-index: 3;
}

.people-img {
  position: absolute;
  right: 9%;
  bottom: 0;
  width: 8em;
  z-index: 2;
}

@media (max-width: 992px) {
  .people-img {
    right: 4%;
  }

  .banner-content {
    padding-right: 12em;
  }
}

@media (max-width: 768px) {
  .people-img {
    right: 3%;
  }

  .banner-content {
    left: 1.1em;
    top: 0.9em;
    padding-right: 11em;
  }

  .banner-title {
    font-size: 1.25em;
  }
}

@media (max-width: 576px) {
  .banner-wrap {
    font-size: 12px;
  }

  .people-img {
    right: 2%;
    bottom: 0;
    width: 8.5em;
  }

  .banner-content {
    left: 1em;
    top: 0.8em;
    padding-right: 9.2em;
  }

  .banner-desc {
    display: none;
  }

  .banner-btn {
    font-size: 0.9em;
    padding: 0.5em 0.9em;
    white-space: normal;
  }

  .banner-close {
    height: 30px;
    width: 30px;
  }
}

@media (max-width: 420px) {
  .people-img {
    display: none;
  }

  .banner-content {
    padding-right: 46px;
  }
}
</style>
